import { render, staticRenderFns } from "./NewsEdit.vue?vue&type=template&id=ad0a1f1e"
import script from "./NewsEdit.vue?vue&type=script&lang=js"
export * from "./NewsEdit.vue?vue&type=script&lang=js"
import style0 from "./NewsEdit.vue?vue&type=style&index=0&id=ad0a1f1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports